<template>
    <div>
        <div class="p-grid">
            <app-menu-bar title="Form Prosedur" back_url="/prosedur" />
            <Card class="p-fluid">
                <template #content>
                    <div class="field grid">
                        <label for="name" class="col-12 mb-2 md:col-2 md:mb-0">Kode </label>
                        <div class="col-12 md:col-10">
                            <InputText id="kode_prosedur" type="text" :class="{ 'p-invalid': errors.kode_prosedur }"
                                v-model="prosedur_data.kode_prosedur" />
                            <small v-if="errors.kode_prosedur" id="name-help" class="p-error">{{ errors.kode_prosedur
                                }}</small>
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="alamat" class="col-12 mb-2 md:col-2 md:mb-0"
                            :class="{ 'p-invalid': errors.nama_prosedur }">Nama </label>
                        <div class="col-12 md:col-10">
                            <InputText id="nama_prosedur" type="text" v-model="prosedur_data.nama_prosedur" />
                            <small v-if="errors.nama_prosedur" id="name-help" class="p-error">{{ errors.nama_prosedur
                                }}</small>
                        </div>
                    </div>

                    <div class="field grid">
                        <label for="tahap" class="col-12 mb-2 md:col-2 md:mb-0"
                            :class="{ 'p-invalid': errors.tahap }">Tahap </label>
                        <div class="col-12 md:col-10">
                            <DataTable :value="prosedur_data.tahap" responsiveLayout="scroll"
                                @rowReorder="onRowReorder">
                                <Column :rowReorder="true" headerStyle="width: 3rem" :reorderableColumn="false" />
                                <Column v-for="col of columns" :field="col.field" :header="col.header" :key="col.field">
                                </Column>
                            </DataTable>
                        </div>

                    </div>

                    <div class="field grid">
                        <label for="tahap" class="col-12 mb-2 md:col-2 md:mb-0"
                            :class="{ 'p-invalid': errors.tahap }">Aksi Tahap </label>
                        <div class="col-10 col-offset-2">
                            <div class="col-3">
                                <Button icon="pi pi-send" label="Tambah Tahap"
                                    class="p-button p-button-primary p-button-sm ml-2" @click="toggle_panel_tahap()" />
                            </div>
                            <OverlayPanel ref="panel_tahap" appendTo="body" :showCloseIcon="true" id="overlay_panel">
                                <div class="field grid">
                                    <label for="name" class="col-12 mb-2 md:col-2 md:mb-0">Nama Tahap </label>
                                    <div class="col-12 md:col-10">
                                        <InputText id="nama_tahap" type="text"
                                            :class="{ 'p-invalid': errors.nama_tahap }"
                                            v-model="temp_tahap.nama_tahap" />
                                        <small v-if="errors.nama_tahap" id="name-help" class="p-error">{{
                                errors.nama_tahap }}</small>
                                    </div>
                                </div>
                                <div class="field grid">
                                    <label for="kode_tahap" class="col-12 mb-2 md:col-2 md:mb-0"
                                        :class="{ 'p-invalid': errors.kode_tahap }">Kode Tahap </label>
                                    <div class="col-12 md:col-10">
                                        <InputText id="kode_tahap" type="text" v-model="temp_tahap.kode_tahap" />
                                        <small v-if="errors.kode_tahap" id="name-help" class="p-error">{{
                                errors.kode_tahap }}</small>
                                    </div>
                                </div>
                                <div class="field grid">
                                    <label for="role" class="col-12 mb-2 md:col-2 md:mb-0"
                                        :class="{ 'p-invalid': errors.asesor }">Asesor </label>
                                    <div class="col-12 md:col-10">
                                        <Dropdown v-model="temp_tahap.asesor" :options="roles" optionLabel="name"
                                            optionValue="name" placeholder="Pilih Role Asesor"
                                            :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
                                            :style="{ width: '300px' }" />
                                    </div>
                                </div>
                                <div class="field grid">
                                    <label for="tipe_tahap" class="col-12 mb-2 md:col-2 md:mb-0"
                                        :class="{ 'p-invalid': errors.asesor }">Tipe Tahap </label>
                                    <div class="col-12 md:col-10">
                                        <Dropdown v-model="temp_tahap.tipe_tahap" :options="daftar_tipe_tahap"
                                            optionLabel="nama" optionValue="nama" placeholder="Pilih Tipe Tahap"
                                            :breakpoints="{ '960px': '75vw', '640px': '100vw' }"
                                            :style="{ width: '300px' }" />
                                    </div>
                                </div>
                                <div class="field grid">
                                    <div class="col-3">
                                        <Button icon="pi pi-send" label="Tambah Tahap"
                                            class="p-button p-button-primary p-button-sm ml-2"
                                            @click="insert_tahap()" />
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </div>




                </template>
                <template #footer>
                    <div class="field grid">
                        <div class="col-offset-2">
                            <Button icon="pi pi-send" label="Simpan" class="p-button p-button-primary ml-2"
                                @click="submitForm()" />
                        </div>
                    </div>
                </template>
            </Card>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Menubar from "primevue/menubar";
import Calendar from "primevue/calendar";
import AppMenuBar from "../../Components/AppMenuBar.vue";
import { FilterMatchMode } from "primevue/api";
import { useForm } from "@inertiajs/inertia-vue3"
import Column from "primevue/column";
import Button from "primevue/button";
import Divider from "primevue/divider";
import Card from "primevue/card";
import DeleteDialog from "../../Components/DeleteDialog";
import { Inertia } from '@inertiajs/inertia'
import MultiSelect from 'primevue/multiselect';
import OverlayPanel from 'primevue/overlaypanel';
import Dropdown from 'primevue/dropdown';

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        Menubar,
        AppMenuBar,
        DataTable,
        Column,
        Button,
        DeleteDialog,
        InputText,
        Password,
        Card,
        Divider,
        MultiSelect,
        Calendar,
        OverlayPanel,
        Dropdown
    },
    props: {
        errors: Array,
        prosedur_data: Array,
        roles: Array,
        permissions: Array,
    },
    data: function () {
        return {
            columns: [
                {
                    field: "nama_tahap",
                    header: "Nama Tahap"
                },
                {
                    field: "kode_tahap",
                    header: "Kode Tahap"
                },
                {
                    field: "asesor",
                    header: "Asesor"
                },
                {
                    field: "tipe_tahap",
                    header: "Tipe Tahap"
                }
            ],
            temp_tahap: {
                id_tahap: null,
                nama_tahap: '',
                kode_tahap: '',
                asesor: '',
                tipe_tahap: '',
            },
            daftar_tipe_tahap: [
                {
                    nama: 'verifikasi'
                },
                {
                    nama: 'validasi'
                }

            ]

        }
    },
    methods: {
        submitForm() {
            // alert(this.form)
            Inertia.put(`/prosedur/${this.prosedur_data.id}`, this.prosedur_data);
        },
        toggle_panel_tahap() {
            this.$refs.panel_tahap.toggle(event);
        },
        insert_tahap() {
            this.prosedur_data.tahap.push(this.temp_tahap);
            this.temp_tahap = {
                id_tahap: null,
                nama_tahap: '',
                kode_tahap: '',
                asesor: '',
                tipe_tahap: '',
            }

            this.$refs.panel_tahap.toggle(event);
        },
        onRowReorder(event) {
            console.log(event.value);
            this.prosedur_data.tahap = JSON.parse(JSON.stringify(event.value));
        }
    }
}
</script>
